























import { defineComponent, PropType, ref } from '@vue/composition-api'
import { useActions, useGetters } from 'vuex-composition-helpers'
import { Page } from '../models/page-viewmodel'
import service from "@/apps/FavoritePagesWidget/services"
import LinkDirective from '@/shared/directives/link-directive'

export default defineComponent({
    name: 'PageEditModeComponent',
    props: {
        item: {
            type: Object as PropType<Page>,
            required: true
        }
    },
    directives: {
        LinkDirective
    },
    setup(props) {
        const toggleDelete = ref(false)
        const { setLoading, setError, removeFavoritePage } = useActions([
            'setLoading', 
            'setError', 
            'removeFavoritePage'
        ])
        const { getConfig } = useGetters(['getConfig'])

        const deleteActive = (status: boolean): void => {
            toggleDelete.value = status
        }

        const getErrorText = (): string => {
            return getConfig.value.language.toLowerCase() === "nl"
                ? "Er gaat iets fout, probeer het later nog een keer"
                : "Something went wrong, please try again later"
        }

        const removeFavorite = (page: Page): void => {
            setLoading(true)

            service.userPreferences.removeMyPage(page.id)
                .then(() => {
                    removeFavoritePage(page)
                })
                .catch((error) => {
                    console.error(error)
                    setError(getErrorText())
                })
                .finally(() => {
                    setLoading(false)
                })
        }

        return {
            toggleDelete,
            deleteActive,
            removeFavorite,
            getConfig
        }
    }
})
